export default "__VITE_ASSET__xO99zZS2__"